import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useCheckingTransferTracking = (depositType: DepositType) => {
  const track = useTracking(screenViewed(depositType))

  return {
    ctaTapped: (depositAmount: string) => track.buttonTapped(ctaTapped(depositAmount, depositType)),
    secondaryCtaTapped: () => track.buttonTapped(secondaryCtaTapped(depositType)),
    confirmModalViewed: () => track.containerViewed(confirmModalViewed(depositType)),
    confirmModalCtaTapped: () => track.buttonTapped(confirmModalCtaTapped(depositType)),
    confirmModalCancelTapped: () => track.buttonTapped(confirmModalCancelTapped(depositType)),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'registrationSpendFirstDeposit',
  screen_name: 'registrationSpendFirstDeposit',
}

type DepositType = 'recurring' | 'one-time'

const screenViewed = (deposit_type: DepositType) => ({
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationSpendFirstDeposit',
  deposit_type,
  ...sharedProps,
})

const ctaTapped = (deposit_amount: string, deposit_type: DepositType) => ({
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendFirstDepositCTA',
  deposit_amount,
  deposit_type,
  ...sharedProps,
})

const secondaryCtaTapped = (deposit_type: DepositType) => ({
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendFirstDepositSecondaryCTA',
  deposit_type,
  ...sharedProps,
})

const confirmModalViewed = (deposit_type: DepositType) => ({
  object: 'Container',
  action: 'Viewed',
  object_name: 'registrationSpendFirstDepositConfirmModal',
  deposit_type,
  ...sharedProps,
})

const confirmModalCtaTapped = (deposit_type: DepositType) => ({
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendFirstDepositConfirmModalCTA',
  deposit_type,
  ...sharedProps,
})

const confirmModalCancelTapped = (deposit_type: DepositType) => ({
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendFirstDepositConfirmModalCancel',
  deposit_type,
  ...sharedProps,
})
